import DB from "@/common/utils/db";
//import axios from "axios";
//接口文档 https://www.tapd.cn/31697456/prong/stories/view/1131697456001000785

/**
 * @description 获取职位列表
 */
export function getPositionList(query) {
  return DB({
    url: "v1/positions",
    method: "get",
    params: query
  });
}
/**
 * @description 获取职能数据
 */
export function getPositionTitle(query) {
  return DB({
    url: "v1/metadata/positionTitle",
    method: "get",
    params: query
  })
}
/**
 * @description 获取职位详情
 */
export function getPositionDetail(query) {
  return DB({
    url: '/v1/positions/' + query.positionId,
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位详情公告
 */
export function getBroadcast(query) {
  return DB({
    url: '/v1/positions/' + query.positionId + '/broadcast',
    method: "get",
    params: query
  });
}
/**
 * @description 获取相似职位
 */
export function getListHomo(query) {
  return DB({
    url: '/v1/ais/listHomologous/position/',
    method: "get",
    params: query
  });
}
/**
 * @description 获取AI人岗匹配
 */
export function getAiTalents(query) {
  return DB({
    url: '/v1/ais/' + query.positionId + '/aiTalents',
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位标签
 */
export function getPositionTags(query) {
  return DB({
    url: "v1/positions/tags",
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位统计数据
 */
export function getPositionStatistics(query) {
  return DB({
    url: "v1/positions/statistics",
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位透镜数据
 */
export function getPositionPortraits(id , query) {
  return DB({
    url: "v1/positions/" + id +"/portraits",
    method: "get",
    params: query
  });
}
/**
 * @description 关注职位
 */
export function followPosition(query) {
  return DB({
    url: "v1/positions/" + query.positionId +"/follow",
    method: "POST",
    params: query
  });
}
/**
 * @description 取消关注职位
 */
export function unfollowPosition(query) {
  return DB({
    url: "v1/positions/" + query.positionId +"/unfollow",
    method: "POST",
    params: query
  });
}
/**
 * @description 获取职位问答数据
 */
export function getPositionQuestions(query) {
  return DB({
    url: "v1/positions/" + query.positionId +"/questions",
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位反馈数据
 */
export function getPositionFeedback(query) {
  return DB({
    url: "v1/positions/" + query.id +"/feedback",
    method: "get",
    params: query
  });
}
/**
 * @description 获取职位动态数据
 */
export function getPositionDynamic(query) {
  return DB({
    url: "v1/positions/" + query.id +"/dynamic",
    method: "get",
    params: query
  });
}

/**
 * @description 推荐须知
 */
export function getRecommendNotice(id , query) {
  return DB({
    url: "v1/enterpris/" + id +"/recommendNotice",
    method: "get",
    params: query
  });
}

export function getSuggest(query) {
  return DB({
    url: 'v1/metadata/suggest',
    method: 'get',
    params: query
  })
}
//判断职位是否打包
export function testBag(query) {
  return DB({
    url: 'v1/positions/existPositionBag',
    method: 'get',
    params: query
  })
}
//职位打包
export function packBag(query) {
  return DB({
    url: 'v1/positions/positionBag',
    method: 'POST',
    params: query
  })
}
